import { Navigate, Outlet } from "react-router-dom";
import { UserRoles } from "../config/global";
import CheckRole from "../utils/CheckRole";

export default function RequireRole({ roles }: { roles: UserRoles[] }) {
  return CheckRole(roles) ? <Outlet /> : <Navigate to={"/403"} />;
}
